import { app } from '../../../../app';
import { Controller } from './whats-new-sidemenu.controller';

app.component('whatsNewSidemenu', {
    controller: Controller,
    templateUrl: require('./whats-new-sidemenu.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/whats-new/whats-new-sidemenu/whats-new-sidemenu.component.js